import {sortWith} from '../../sortWith'
import {comparator} from './comparator'

export const labelComparator = <T extends {label: string}>(a: T, b: T): number => comparator(a, b, 'label')

export const sortWithLabel = sortWith(labelComparator)
